import { roleBasedAccessControlConstants } from "../constants";

function hasUserHasRole({ roleName, scope }) {
  const role = roleBasedAccessControlConstants.RBAC.find(
    (r) => r.name === roleName
  );

  if (!role) {
    return false; // Role not found
  }

  return role.scopes.includes(scope);
}

function hasEditPermission(
  userDetails,
  scope = roleBasedAccessControlConstants.scopes.project.edit
) {
  if (!userDetails) return false;

  const roleName =
    userDetails?.signInUserSession?.accessToken?.payload?.["cognito:groups"]
      ?.filter((ite) =>
        roleBasedAccessControlConstants.data360Roles.includes(ite)
      )
      ?.sort(roleBasedAccessControlConstants.data360Roles.customSort)[0] || "";

  return hasUserHasRole({ roleName, scope });
}

export { hasUserHasRole, hasEditPermission };
